{
  "route.tiers.title": "层级与福利",
  "benefits.deleteBenefit.deleteDialog.header": "是否确定要删除此福利？",
  "benefits.deleteBenefit.deleteDialog.content": "删除此福利后，层级会员将不再享受此福利。",
  "benefits.deleteBenefit.alertDialog.header": "您无法删除此福利。",
  "benefits.deleteBenefit.alertDialog.content": "此福利已附加给尚未兑换的会员。请尝试从福利包中取消选择此福利。",
  "benefits.deleteBenefit.failureAlert": "删除此福利时出现错误。",
  "benefits.purchaseBenefits.text": "{pointsText} = {currencySymbol}{pointsSpent} 已消费",
  "benefits.pointsFromPurchases": "来自购买的 {pointsPlaceHolder}",
  "benefits.pointsCatalogBenefitData": "附加 {pointsPlaceHolder}",
  "benefits.createNew.button.tooltip": "您必须选择编辑下一版本才能编辑和重新启动福利。",
  "benefits.createNew.button.label": "创建福利",
  "benefits.header.title.regular": "创建固定福利并将其分配给层级。您可以在层级设置中定义积分值和购买要求。",
  "benefits.header.title.additional": "创建附加福利以提供给忠诚度会员。您可以在忠诚度 API 中管理和分配附加福利。",
  "benefits.header.title.fixedBenefits.learnMoreLinkText": "了解更多",
  "benefits.header.title.fixedBenefits": "创建固定福利并将其分配给层级。您可以在层级设置中定义积分值和购买要求。{learnMoreLink}。",
  "benefits.header.title.additionalBenefits.learnMoreLinkText": "了解更多",
  "benefits.header.title.additionalBenefits": "创建附加福利以提供给忠诚度会员。您可以使用忠诚度 API 或会员参数文件管理和分配附加福利。{learnMoreLink}。",
  "benefitDefaultData.singleCurrencyText.points": "每消费 1{symbol} 可获 1 积分",
  "tiers.header.title.learnMoreLinkText": "了解更多",
  "tiers.header.title": "创建和编辑您的层级。启动计划后，您只能添加层级，而不能删除它们。{learnMoreLink}。",
  "tiers.editIcon.tooltip": "要编辑此层级，您需要完成之前的层级设置。",
  "tiers.reviewIcon.tooltip": "显示层级设置",
  "tiers.status.inactive.tooltip": "您需要完成此层级的设置。",
  "tiers.cardSubtitle.points.text.invitationOnly": "仅邀请层级",
  "tiers.cardSubtitle.points.text.pointsUnderMax": "{points} - 每年赚取 {maxPoints} {pointsText}",
  "tiers.cardSubtitle.points.text.pointsAtMax": "每年赚取 {points} + {pointsText}",
  "tiers.cardSubtitle.purchasesRequired.plural.zero": "",
  "tiers.cardSubtitle.purchasesRequired.plural.one": "需要 {number} 次购买",
  "tiers.cardSubtitle.purchasesRequired.plural.two": "需要 {number} 次购买",
  "tiers.cardSubtitle.purchasesRequired.plural.few": "需要 {number} 次购买",
  "tiers.cardSubtitle.purchasesRequired.plural.many": "需要 {number} 次购买",
  "tiers.cardSubtitle.purchasesRequired.plural.other": "需要 {number} 次购买",
  "tiers.deleteTierDialog.headline": "是否确定要删除此层级？",
  "tiers.deleteTierDialog.content": "删除此层级后，层级成员将下降到较低层级，并且不再享有当前层级福利。",
  "tiers.addNewCard.tooltip.invalid": "要创建此层级，您需要完成之前的层级设置。",
  "tiers.addNewCard.text": "创建层级",
  "tierSetup.deleteCatalogBenefitDialog.headline": "是否确定要删除此福利？",
  "tierSetup.deleteCatalogBenefitDialog.content": "删除此福利后，层级会员将不再享受此福利。",
  "tierSetup.title.new": "创建层级",
  "tierSetup.title.edit": "层级设置 -{name}",
  "benefitSetup.title.new": "创建福利",
  "benefitSetup.title.edit": "编辑福利",
  "benefitSetup.type.title": "选择福利类型",
  "benefitSetup.benefitName.title": "福利名称",
  "benefitSetup.benefitName.tooltip": "输入向会员显示的此福利的名称。",
  "benefitSetup.targetMarkets.label": "选择市场",
  "benefitSetup.targetMarkets.tooltip": "选择此福利的目标市场。确保为所选市场设置奖励池。",
  "benefitSetup.notification": "要将事件设置为固定福利，您首先需要创建事件操作。您可以使用所选操作定义此福利的各个层级奖励。事件固定福利由自动化中心程序触发。",
  "benefitSetupCustomFields.custom.label": "自定义奖励",
  "benefitSetupCustomFields.custom.tooltip": "向会员显示的奖励名称。您可以决定如何兑换奖励。",
  "benefitSetupEventFields.eventActionId.label": "选择操作",
  "benefitSetupEventFields.eventActionId.placeholder": "-- 选择操作 --",
  "benefitSetupEventFields.tiersAndRewards.title": "层级和奖励",
  "benefitSetupEventFields.tiersAndRewards.tooltip": "您可以使用所选操作定义层级和奖励。奖励显示在此层级的固定福利表中。",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.label": "选择访问权限",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.placeholder": "-- 选择访问权限 --",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.tooltip": "此福利的奖励可通过访问权限兑换。为每个层级选择一个活动的访问权限。",
  "benefitSetupVoucherFields.rewardId.label": "选择优惠券池",
  "benefitSetupVoucherFields.rewardId.placeholder": "-- 选择优惠券池 --",
  "benefitSetupVoucherFields.rewardId.tooltip": "此福利的奖励可通过优惠券兑换。为每个层级选择一个活动的优惠券池。",
  "benefitSetupVoucherFields.tiersAndRewards.title": "选择层级和奖励池",
  "benefitSetupVoucherFields.tiersAndRewards.tooltip": "此福利的奖励可通过优惠券兑换。为每个层级选择一个活动的优惠券池。",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.title": "选择层级和访问权限",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.tooltip": "此福利的奖励可通过访问权限兑换。为每个层级选择一个活动的访问权限。",
  "tierSetupGeneral.tierValueInPointsTooltip.spend": "定义进入此层级所需的最低业绩金额。",
  "tierSetupGeneral.tierValueInPointsTooltip.points": "定义进入此层级所需的最低积分。",
  "tierSetupGeneral.tierValueInPointsTooltip.other": "第一层级是入门层级，对所有忠诚度会员开放，没有任何要求。",
  "tierSetupGeneral.numberOfPurchasesTooltip.pointsOrSpend": "定义进入此层级所需的最低购买量。此要求是可选的，可以作为积分要求的补充。",
  "tierSetupGeneral.title": "常规设置",
  "tierSetupGeneral.tierType.label": "层级类型",
  "tierSetupGeneral.inviteTier.notification": "通过调用忠诚度 API 或在会员参数文件中手动管理您这边的付款和邀请，并将会员添加到层级。获得的积分将根据您的计划设置自动计算。您还可以在 API 或会员参数文件中定义退出层级的会员的操作。",
  "tierSetupGeneral.tierName.label": "层级名称",
  "tierSetupGeneral.tierName.tooltip": "输入显示给会员的此层级的名称。该名称还会在个性化服务中显示为忠诚度令牌。",
  "tierSetupGeneral.tierIcon.label": "层级图标",
  "tierSetupGeneral.tierIcon.tooltip": "选择向会员显示的图标。该图标还会在个性化服务中显示为忠诚度令牌。",
  "tierSetupGeneral.tierIcon.iconText": "添加到层级",
  "tierSetupGeneral.requirements.title": "要求",
  "tierSetupGeneral.tierPoints.label.points": "层级价值（以积分计）",
  "tierSetupGeneral.tierPoints.label.spend": "层级所需总业绩",
  "tierSetupGeneral.tierPoints.postfixLabel.points": "积分",
  "tierSetupGeneral.tierPoints.postfixLabel.loyalty": "积分",
  "tierSetupGeneral.tierPoints.postfixLabel.status": "状态积分",
  "tierSetupGeneral.tierPoints.postfixLabel.balance": "消费积分",
  "tierSetupGeneral.tierPurchases.label": "层级所需购买数",
  "tierSetupGeneral.tierPurchases.postfixLabel": "购买",
  "tierSetupGeneral.calculation.tierDropout.label": "层级计算",
  "tierSetupGeneral.calculation.tierDropout.tooltip": "选择是否要将此层级纳入层级计算，否则将不进行层级计算和退出。",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.label": "层级过期",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.tooltip": "要使特定层级到期并在与其他层级不同的时间重新计算，请更改此设置。",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.postfixLabel": "年",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.label": "层级过期",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.tooltip": "要使特定层级到期并在与其他层级不同的时间重新计算，请更改此设置。",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.postfixLabel": "月",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.equal": "每消费 1 {symbol} 奖励 1 单位业绩",
  "tierSetupPurchaseBenefits.catalogSelector.label": "选择品牌和类别",
  "tierSetupPurchaseBenefits.catalogSelector.placeholder": "选择要促销的特定品牌或类别。",
  "tierSetupPurchaseBenefits.catalogSelector.disabledItemsTooltip": "此类别/品牌已在之前的福利中选择。",
  "tierSetupPurchaseBenefits.benefitMessageHeader.title": "福利消息",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltipText": "显示消息格式",
  "tierSetupPurchaseBenefits.benefitMessageTitle.label": "标题",
  "tierSetupPurchaseBenefits.benefitMessageTitle.placeholder": "输入福利消息标题",
  "tierSetupPurchaseBenefits.benefitMessageText.label": "文本",
  "tierSetupPurchaseBenefits.benefitMessageText.placeholder": "输入福利消息文本",
  "tierSetupPurchaseBenefits.benefitMessageText.tooltip": "向会员显示的积分和货币价值取决于您网站上选择的货币。",
  "tierSetupPurchaseBenefits.benefitIcon.label": "福利图标",
  "tierSetupPurchaseBenefits.benefitIcon.selectIconText": "添加到福利",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.selectedItems": "仅为选定的品牌、类别或操作奖励积分",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.first": "为购买特定品牌或产品类别的会员分配不同的积分值。奖励积分而不是（而不是额外）标准购买积分。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.other": "如果某件商品属于多个类别，且有自己的积分值，则会员始终获得最高定义值的奖励。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.first": "为购买特定品牌或类别的会员分配不同的业绩率。业绩率用于更新购买的业绩余额，而不是标准比率。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.other": "如果某件商品属于多个类别，且有自己的比率值，则会员始终获得最高定义值的奖励。",
  "tierSetupPurchaseBenefits.notification": "积分是所有会员的忠诚度计划货币。确保在所有货币中保持统一的积分值。",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.zero": "最少需要 {number} 积分",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.one": "最少需要 {number} 积分",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.two": "最少需要 {number} 积分",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.few": "最少需要 {number} 积分",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.many": "最少需要 {number} 积分",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.other": "最少需要 {number} 积分",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.zero": "最少需要 {number} 业绩",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.one": "最少需要 {number} 业绩",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.two": "最少需要 {number} 业绩",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.few": "最少需要 {number} 业绩",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.many": "最少需要 {number} 业绩",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.other": "最少需要 {number} 业绩",
  "tierSetupPurchaseBenefits.pointsType.title": "层级积分类型",
  "tierSetupPurchaseBenefits.pointsType.label": "积分类型",
  "tierSetupPurchaseBenefits.pointsType.tooltip": "定义会员在层级内可获得的积分类型。",
  "tierSetupPurchaseBenefits.pointsType.error": "积分类型与积分倍增的操作定义相冲突。修复操作：{actions} 然后重试。",
  "tierSetupPurchaseBenefits.pointsType.options.loyalty": "积分（状态积分和消费积分）",
  "tierSetupPurchaseBenefits.pointsType.options.status": "仅状态积分",
  "tierSetupPurchaseBenefits.pointsType.options.spend": "仅消费积分",
  "tierSetupPurchaseBenefits.header.points": "来自购买的积分",
  "tierSetupPurchaseBenefits.header.spend": "来自购买的忠诚度业绩",
  "tierSetupPurchaseBenefits.header.tooltip.spend": "选择会员通过购买获得的积分金额。累积值将显示在会员的 Loyalty Wallet 中。",
  "tierSetupPurchaseBenefits.header.tooltip.points": "选择会员通过购买获得的积分金额。如果您管理多种货币，则必须为每种货币设置值。如果您不想为购买奖励积分，此设置对所有货币都相同。",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltip": "输入此优惠的促销信息，该信息将显示在会员的 Loyalty Wallet 中。",
  "tierSetupPurchaseBenefits.catalogBenefit.title.points": "来自品牌或类别的积分。",
  "tierSetupPurchaseBenefits.catalogBenefit.title.spend": "来自品牌或类别的忠诚度积分",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.points": "添加积分值 ",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.spend": "添加忠诚度积分值 ",
  "tierSetupVisibility.title": "可见性",
  "tierSetupVisibility.tooltip": "您可以向会员隐藏此层级并阻止任何新条目。在您将现有会员迁移到另一个层级之前，该层级仍然对现有会员可见。根据您的计划设置，积分计算将自动继续。",
  "tierSetupVisibility.visible.label": "选择层级模式",
  "visibility.options.visible": "可见层级",
  "visibility.options.invisible": "隐藏层级",
  "multiLangPurchaseBenefitFields.alert": "输入所有语言的标题和文本。",
  "additionalBenefitsUpdateValidator.confirmed.isTrue": "确保输入所有必填信息。",
  "additionalBenefitsUpdateValidator.reason.presence": "输入原因以进行内部跟踪。",
  "benefitValidator.defaultConstraints.name.presence": "输入福利名称。",
  "benefitValidator.defaultConstraints.targetMarkets.presence": "输入市场。",
  "benefitValidator.eventActionId.presence": "输入操作。",
  "benefitValidator.custom.presence": "输入奖励描述。",
  "benefitValidator.tiers.atLeastOneTier": "至少选择一个层级。",
  "benefitValidator.rewardConstraints.rewardId.presence": "输入奖励池。",
  "benefitValidator.rewardConstraints.tiers.atLeastOneTier": "至少选择一个层级。",
  "benefitValidator.rewardConstraints.tiers.tierId.rewardId.benefitSingleReward": "空选择。",
  "benefitValidator.rewardConstraints.exclusiveAccessIds.presence": "输入访问权限。",
  "tiersCreationValidator.numberOfTiers.presence": "输入层级数（1-10 之间的数字）。",
  "tiersCreationValidator.numberOfTiers.numericality.notInteger": "输入层级数（1-10 之间的数字）。",
  "tiersCreationValidator.numberOfTiers.numericality.notLessThan": "输入层级数（1-10 之间的数字）。",
  "tiersCreationValidator.numberOfTiers.numericality.notGreaterThan": "至少输入两个分配层级。",
  "tiersCreationValidator.spend.presence": "输入整数消费金额。",
  "tiersCreationValidator.spend.numericality.notInteger": "输入整数消费金额。",
  "tiersCreationValidator.spend.numericality.notGreaterThan": "输入大于前一层级的整数消费金额。",
  "rangeTierPoints.nextTierPoints.plural.zero": "最多需要 {number} 积分",
  "rangeTierPoints.nextTierPoints.plural.one": "最多需要 {number} 积分",
  "rangeTierPoints.nextTierPoints.plural.two": "最多需要 {number} 积分",
  "rangeTierPoints.nextTierPoints.plural.few": "最多需要 {number} 积分",
  "rangeTierPoints.nextTierPoints.plural.many": "最多需要 {number} 积分",
  "rangeTierPoints.nextTierPoints.plural.other": "最多需要 {number} 积分",
  "rangeTierPoints.prevTierPoints.plural.zero": "最少需要 {number} 积分。",
  "rangeTierPoints.prevTierPoints.plural.one": "最少需要 {number} 积分。",
  "rangeTierPoints.prevTierPoints.plural.two": "最少需要 {number} 积分。",
  "rangeTierPoints.prevTierPoints.plural.few": "最少需要 {number} 积分。",
  "rangeTierPoints.prevTierPoints.plural.many": "最少需要 {number} 积分。",
  "rangeTierPoints.prevTierPoints.plural.other": "最少需要 {number} 积分。",
  "tierValidator.name.presence": "输入层级名称。",
  "tierValidator.name.exclusionIgnoreCase": "此名称已存在。输入唯一名称。",
  "tierValidator.nameML.multiLangField": "为每种语言输入层级名称。",
  "tierValidator.points.presence": "输入层级值（以积分计）。",
  "tierValidator.pointsBenefit.titleML.multiLangField": "为每种语言输入标题。",
  "tierValidator.pointsBenefit.textML.multiLangField": "为每种语言输入文本。",
  "tierValidator.purchaseBenefits.pointsCatalogBenefits.purchaseBenefitCatalog": "输入目录选择。",
  "tierValidator.pointsRates.points.presence": "输入积分。",
  "tierValidator.pointsRates.spent.numericality.notInteger": "输入大于零的消费。",
  "tierValidator.pointsRates.spent.numericality.notGreaterThan": "输入大于零的消费。",
  "tierValidator.pointsRates.spent.presence": "输入大于零的数。",
  "benefitDefaultData.pointsBenefitTitle.points": "通过购买赚取的积分",
  "benefitDefaultData.pointsBenefitTitle.spend": "通过购买赚取忠诚度业绩",
  "benefitDefaultData.singleCurrencyText.spend": "购买并从购买中赚取业绩",
  "purchasePointsToken.display": "{x 积分/秒}",
  "purchasePointsToken.display.balance": "{消费 x 积分/秒}",
  "purchasePointsToken.display.status": "{x 状态积分/秒}",
  "purchaseCurrencyToken.display": "{ x currency }",
  "distribution.contentBox.notification": "预览现有客户库将如何在各个层级之间分配。您可以在启动第一个计划之前修改联系人分布。",
  "distribution.contentBox.title": "层级创建",
  "distribution.contentBox.numberOfTiers.label": "层级数量",
  "distribution.contentBox.calcPeriod.label": "计算期间",
  "distribution.contentBox.calcPeriod.tooltip": "选择要使用多少历史数据来计算联系人分布。",
  "distribution.contentBox.preview.title": "联系人分配预览",
  "distribution.contentBox.preview.tooltip": "仅当联系人满足某一层级的所有要求时，才会将其分配到该层级。",
  "distribution.contentBox.updateChartButton.label": "更新图表",
  "distribution.contentBox.chart.column.label": "客户数量",
  "distribution.contentBox.chart.series.name": "占所有客户的百分比",
  "distribution.contentBox.singleTierSettings.tooltip.first": "第一层级是入门层级，面向所有忠诚度客户开放，没有入门要求。",
  "distribution.contentBox.singleTierSettings.tooltip.spend": "将客户在选定期间内归入此层级的最低总消费额。",
  "distribution.contentBox.singleTierSettings.tooltip.purchases": "将客户在选定期间内归入此层级的最低购买次数。",
  "distribution.contentBox.singleTierSettings.spend.label": "所需消费",
  "distribution.contentBox.singleTierSettings.purchases.label": "购买数量",
  "tierSetupGeneral.tierPoints.postfixLabel.spend": "{value} 支出",
  "benefitDefaultData.pointsBenefitText.multiCurrency": "为每个 {{currencyToken}} 支出获取 {{pointsToken}}"
}
